// extracted by mini-css-extract-plugin
module.exports = {"headerReinsurance":"oeKmi","dot":"_25Qpv","rotateText":"_1mbeR","rotate-text-up":"_3tEa7"};